/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CertificateImportAction } from '../model';
// @ts-ignore
import type { CertificateReference } from '../model';
// @ts-ignore
import type { CertificateStore } from '../model';
// @ts-ignore
import type { Expired } from '../model';
// @ts-ignore
import type { ExportPrivateKeysRequestBody } from '../model';
// @ts-ignore
import type { KeyExportFormat } from '../model';
// @ts-ignore
import type { Match } from '../model';
// @ts-ignore
import type { MissingKeyAction } from '../model';
// @ts-ignore
import type { MissingKeyAlias } from '../model';
// @ts-ignore
import type { ObjectEncoding } from '../model';
// @ts-ignore
import type { X509CertificateDetails } from '../model';
/**
 * CertificateApi - axios parameter creator
 * @export
 */
export const CertificateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerDeleteCertificate: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerDeleteCertificate', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateControllerDeleteCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/deleteCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerDeleteCertificates: async (store: CertificateStore, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerDeleteCertificates', 'store', store)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateControllerDeleteCertificates', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/deleteCertificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {ObjectEncoding} encoding 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportCertificate: async (store: CertificateStore, thumbprint: string, encoding: ObjectEncoding, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerExportCertificate', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateControllerExportCertificate', 'thumbprint', thumbprint)
            // verify required parameter 'encoding' is not null or undefined
            assertParamExists('certificateControllerExportCertificate', 'encoding', encoding)
            const localVarPath = `/api/certificate/exportCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }

            if (encoding !== undefined) {
                localVarQueryParameter['encoding'] = encoding;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ObjectEncoding} encoding 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportCertificateChain: async (encoding: ObjectEncoding, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encoding' is not null or undefined
            assertParamExists('certificateControllerExportCertificateChain', 'encoding', encoding)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateControllerExportCertificateChain', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/exportCertificateChain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (encoding !== undefined) {
                localVarQueryParameter['encoding'] = encoding;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {ObjectEncoding} encoding 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportCertificates: async (store: CertificateStore, encoding: ObjectEncoding, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerExportCertificates', 'store', store)
            // verify required parameter 'encoding' is not null or undefined
            assertParamExists('certificateControllerExportCertificates', 'encoding', encoding)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('certificateControllerExportCertificates', 'requestBody', requestBody)
            const localVarPath = `/api/certificate/exportCertificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (encoding !== undefined) {
                localVarQueryParameter['encoding'] = encoding;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {KeyExportFormat} keyExportFormat 
         * @param {ExportPrivateKeysRequestBody} exportPrivateKeysRequestBody 
         * @param {boolean} [includeRoot] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportPrivateKeys: async (store: CertificateStore, keyExportFormat: KeyExportFormat, exportPrivateKeysRequestBody: ExportPrivateKeysRequestBody, includeRoot?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerExportPrivateKeys', 'store', store)
            // verify required parameter 'keyExportFormat' is not null or undefined
            assertParamExists('certificateControllerExportPrivateKeys', 'keyExportFormat', keyExportFormat)
            // verify required parameter 'exportPrivateKeysRequestBody' is not null or undefined
            assertParamExists('certificateControllerExportPrivateKeys', 'exportPrivateKeysRequestBody', exportPrivateKeysRequestBody)
            const localVarPath = `/api/certificate/exportPrivateKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (keyExportFormat !== undefined) {
                localVarQueryParameter['keyExportFormat'] = keyExportFormat;
            }

            if (includeRoot !== undefined) {
                localVarQueryParameter['includeRoot'] = includeRoot;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportPrivateKeysRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificate: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerGetCertificate', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateControllerGetCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/getCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificateDetails: async (chain?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/getCertificateDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


            if (chain !== undefined) { 
                localVarFormParams.append('chain', chain as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return a list of objects that references the provided certificate. 
         * @summary Get all the references to a certificate
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificateReferencedDetails: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerGetCertificateReferencedDetails', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateControllerGetCertificateReferencedDetails', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/getCertificateReferencedDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificates: async (store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerGetCertificates', 'store', store)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerGetCertificates', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerGetCertificates', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/getCertificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificatesCount: async (store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerGetCertificatesCount', 'store', store)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerGetCertificatesCount', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerGetCertificatesCount', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/getCertificatesCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {File} [certificates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportCertificates: async (store: CertificateStore, importAction: CertificateImportAction, certificates?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerImportCertificates', 'store', store)
            // verify required parameter 'importAction' is not null or undefined
            assertParamExists('certificateControllerImportCertificates', 'importAction', importAction)
            const localVarPath = `/api/certificate/importCertificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (importAction !== undefined) {
                localVarQueryParameter['importAction'] = importAction;
            }


            if (certificates !== undefined) { 
                localVarFormParams.append('certificates', certificates as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportCertificatesBase64: async (store: CertificateStore, importAction: CertificateImportAction, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerImportCertificatesBase64', 'store', store)
            // verify required parameter 'importAction' is not null or undefined
            assertParamExists('certificateControllerImportCertificatesBase64', 'importAction', importAction)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('certificateControllerImportCertificatesBase64', 'body', body)
            const localVarPath = `/api/certificate/importCertificatesBase64`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (importAction !== undefined) {
                localVarQueryParameter['importAction'] = importAction;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportCertificatesPEM: async (store: CertificateStore, importAction: CertificateImportAction, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerImportCertificatesPEM', 'store', store)
            // verify required parameter 'importAction' is not null or undefined
            assertParamExists('certificateControllerImportCertificatesPEM', 'importAction', importAction)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('certificateControllerImportCertificatesPEM', 'body', body)
            const localVarPath = `/api/certificate/importCertificatesPEM`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (importAction !== undefined) {
                localVarQueryParameter['importAction'] = importAction;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {MissingKeyAction} missingKeyAction 
         * @param {string} [keyStorePassword] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportPrivateKeys: async (store: CertificateStore, missingKeyAction: MissingKeyAction, keyStorePassword?: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerImportPrivateKeys', 'store', store)
            // verify required parameter 'missingKeyAction' is not null or undefined
            assertParamExists('certificateControllerImportPrivateKeys', 'missingKeyAction', missingKeyAction)
            const localVarPath = `/api/certificate/importPrivateKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (missingKeyAction !== undefined) {
                localVarQueryParameter['missingKeyAction'] = missingKeyAction;
            }


            if (keyStorePassword !== undefined) { 
                localVarFormParams.append('keyStorePassword', keyStorePassword as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportSystemRoots: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/importSystemRoots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return true if the certificate is referenced. 
         * @summary Checks if the certificate is referenced
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerIsCertificateReferenced: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerIsCertificateReferenced', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateControllerIsCertificateReferenced', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/isCertificateReferenced`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} email 
         * @param {Match} match 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByEmail: async (store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmail', 'store', store)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmail', 'email', email)
            // verify required parameter 'match' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmail', 'match', match)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmail', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmail', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/searchForCertificatesByEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (match !== undefined) {
                localVarQueryParameter['match'] = match;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} email 
         * @param {Match} match 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByEmailCount: async (store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmailCount', 'store', store)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmailCount', 'email', email)
            // verify required parameter 'match' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmailCount', 'match', match)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmailCount', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByEmailCount', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/searchForCertificatesByEmailCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (match !== undefined) {
                localVarQueryParameter['match'] = match;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} issuer 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByIssuer: async (store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuer', 'store', store)
            // verify required parameter 'issuer' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuer', 'issuer', issuer)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuer', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuer', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/searchForCertificatesByIssuer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (issuer !== undefined) {
                localVarQueryParameter['issuer'] = issuer;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} issuer 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByIssuerCount: async (store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuerCount', 'store', store)
            // verify required parameter 'issuer' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuerCount', 'issuer', issuer)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuerCount', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesByIssuerCount', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/searchForCertificatesByIssuerCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (issuer !== undefined) {
                localVarQueryParameter['issuer'] = issuer;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} subject 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesBySubject: async (store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubject', 'store', store)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubject', 'subject', subject)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubject', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubject', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/searchForCertificatesBySubject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} subject 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesBySubjectCount: async (store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubjectCount', 'store', store)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubjectCount', 'subject', subject)
            // verify required parameter 'expired' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubjectCount', 'expired', expired)
            // verify required parameter 'missingKeyAlias' is not null or undefined
            assertParamExists('certificateControllerSearchForCertificatesBySubjectCount', 'missingKeyAlias', missingKeyAlias)
            const localVarPath = `/api/certificate/searchForCertificatesBySubjectCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (subject !== undefined) {
                localVarQueryParameter['subject'] = subject;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (missingKeyAlias !== undefined) {
                localVarQueryParameter['missingKeyAlias'] = missingKeyAlias;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertificateApi - functional programming interface
 * @export
 */
export const CertificateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerDeleteCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerDeleteCertificate(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerDeleteCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerDeleteCertificates(store: CertificateStore, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerDeleteCertificates(store, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerDeleteCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {ObjectEncoding} encoding 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerExportCertificate(store: CertificateStore, thumbprint: string, encoding: ObjectEncoding, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerExportCertificate(store, thumbprint, encoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerExportCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ObjectEncoding} encoding 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerExportCertificateChain(encoding: ObjectEncoding, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerExportCertificateChain(encoding, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerExportCertificateChain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {ObjectEncoding} encoding 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerExportCertificates(store: CertificateStore, encoding: ObjectEncoding, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerExportCertificates(store, encoding, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerExportCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {KeyExportFormat} keyExportFormat 
         * @param {ExportPrivateKeysRequestBody} exportPrivateKeysRequestBody 
         * @param {boolean} [includeRoot] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerExportPrivateKeys(store: CertificateStore, keyExportFormat: KeyExportFormat, exportPrivateKeysRequestBody: ExportPrivateKeysRequestBody, includeRoot?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerExportPrivateKeys(store, keyExportFormat, exportPrivateKeysRequestBody, includeRoot, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerExportPrivateKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerGetCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerGetCertificate(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerGetCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerGetCertificateDetails(chain?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerGetCertificateDetails(chain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerGetCertificateDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return a list of objects that references the provided certificate. 
         * @summary Get all the references to a certificate
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerGetCertificateReferencedDetails(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CertificateReference>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerGetCertificateReferencedDetails(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerGetCertificateReferencedDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerGetCertificates(store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerGetCertificates(store, expired, missingKeyAlias, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerGetCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerGetCertificatesCount(store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerGetCertificatesCount(store, expired, missingKeyAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerGetCertificatesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {File} [certificates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerImportCertificates(store: CertificateStore, importAction: CertificateImportAction, certificates?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerImportCertificates(store, importAction, certificates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerImportCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerImportCertificatesBase64(store: CertificateStore, importAction: CertificateImportAction, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerImportCertificatesBase64(store, importAction, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerImportCertificatesBase64']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerImportCertificatesPEM(store: CertificateStore, importAction: CertificateImportAction, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerImportCertificatesPEM(store, importAction, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerImportCertificatesPEM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {MissingKeyAction} missingKeyAction 
         * @param {string} [keyStorePassword] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerImportPrivateKeys(store: CertificateStore, missingKeyAction: MissingKeyAction, keyStorePassword?: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerImportPrivateKeys(store, missingKeyAction, keyStorePassword, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerImportPrivateKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerImportSystemRoots(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerImportSystemRoots(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerImportSystemRoots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return true if the certificate is referenced. 
         * @summary Checks if the certificate is referenced
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerIsCertificateReferenced(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerIsCertificateReferenced(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerIsCertificateReferenced']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} email 
         * @param {Match} match 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerSearchForCertificatesByEmail(store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerSearchForCertificatesByEmail(store, email, match, expired, missingKeyAlias, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerSearchForCertificatesByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} email 
         * @param {Match} match 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerSearchForCertificatesByEmailCount(store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerSearchForCertificatesByEmailCount(store, email, match, expired, missingKeyAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerSearchForCertificatesByEmailCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} issuer 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerSearchForCertificatesByIssuer(store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerSearchForCertificatesByIssuer(store, issuer, expired, missingKeyAlias, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerSearchForCertificatesByIssuer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} issuer 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerSearchForCertificatesByIssuerCount(store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerSearchForCertificatesByIssuerCount(store, issuer, expired, missingKeyAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerSearchForCertificatesByIssuerCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} subject 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerSearchForCertificatesBySubject(store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerSearchForCertificatesBySubject(store, subject, expired, missingKeyAlias, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerSearchForCertificatesBySubject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} subject 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateControllerSearchForCertificatesBySubjectCount(store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateControllerSearchForCertificatesBySubjectCount(store, subject, expired, missingKeyAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.certificateControllerSearchForCertificatesBySubjectCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CertificateApi - factory interface
 * @export
 */
export const CertificateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertificateApiFp(configuration)
    return {
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerDeleteCertificate(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<void> {
            return localVarFp.certificateControllerDeleteCertificate(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerDeleteCertificates(store: CertificateStore, requestBody: Array<string>, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.certificateControllerDeleteCertificates(store, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {ObjectEncoding} encoding 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportCertificate(store: CertificateStore, thumbprint: string, encoding: ObjectEncoding, options?: any): AxiosPromise<string> {
            return localVarFp.certificateControllerExportCertificate(store, thumbprint, encoding, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ObjectEncoding} encoding 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportCertificateChain(encoding: ObjectEncoding, thumbprint: string, options?: any): AxiosPromise<string> {
            return localVarFp.certificateControllerExportCertificateChain(encoding, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {ObjectEncoding} encoding 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportCertificates(store: CertificateStore, encoding: ObjectEncoding, requestBody: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.certificateControllerExportCertificates(store, encoding, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {KeyExportFormat} keyExportFormat 
         * @param {ExportPrivateKeysRequestBody} exportPrivateKeysRequestBody 
         * @param {boolean} [includeRoot] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerExportPrivateKeys(store: CertificateStore, keyExportFormat: KeyExportFormat, exportPrivateKeysRequestBody: ExportPrivateKeysRequestBody, includeRoot?: boolean, options?: any): AxiosPromise<string> {
            return localVarFp.certificateControllerExportPrivateKeys(store, keyExportFormat, exportPrivateKeysRequestBody, includeRoot, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificate(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.certificateControllerGetCertificate(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificateDetails(chain?: File, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerGetCertificateDetails(chain, options).then((request) => request(axios, basePath));
        },
        /**
         * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return a list of objects that references the provided certificate. 
         * @summary Get all the references to a certificate
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificateReferencedDetails(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<Array<CertificateReference>> {
            return localVarFp.certificateControllerGetCertificateReferencedDetails(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificates(store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerGetCertificates(store, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerGetCertificatesCount(store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: any): AxiosPromise<number> {
            return localVarFp.certificateControllerGetCertificatesCount(store, expired, missingKeyAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {File} [certificates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportCertificates(store: CertificateStore, importAction: CertificateImportAction, certificates?: File, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerImportCertificates(store, importAction, certificates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportCertificatesBase64(store: CertificateStore, importAction: CertificateImportAction, body: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerImportCertificatesBase64(store, importAction, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {CertificateImportAction} importAction 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportCertificatesPEM(store: CertificateStore, importAction: CertificateImportAction, body: string, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerImportCertificatesPEM(store, importAction, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {MissingKeyAction} missingKeyAction 
         * @param {string} [keyStorePassword] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportPrivateKeys(store: CertificateStore, missingKeyAction: MissingKeyAction, keyStorePassword?: string, file?: File, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerImportPrivateKeys(store, missingKeyAction, keyStorePassword, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerImportSystemRoots(options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerImportSystemRoots(options).then((request) => request(axios, basePath));
        },
        /**
         * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return true if the certificate is referenced. 
         * @summary Checks if the certificate is referenced
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerIsCertificateReferenced(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.certificateControllerIsCertificateReferenced(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} email 
         * @param {Match} match 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByEmail(store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerSearchForCertificatesByEmail(store, email, match, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} email 
         * @param {Match} match 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByEmailCount(store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: any): AxiosPromise<number> {
            return localVarFp.certificateControllerSearchForCertificatesByEmailCount(store, email, match, expired, missingKeyAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} issuer 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByIssuer(store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerSearchForCertificatesByIssuer(store, issuer, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} issuer 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesByIssuerCount(store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: any): AxiosPromise<number> {
            return localVarFp.certificateControllerSearchForCertificatesByIssuerCount(store, issuer, expired, missingKeyAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} subject 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesBySubject(store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.certificateControllerSearchForCertificatesBySubject(store, subject, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} subject 
         * @param {Expired} expired 
         * @param {MissingKeyAlias} missingKeyAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateControllerSearchForCertificatesBySubjectCount(store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: any): AxiosPromise<number> {
            return localVarFp.certificateControllerSearchForCertificatesBySubjectCount(store, subject, expired, missingKeyAlias, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificateApi - object-oriented interface
 * @export
 * @class CertificateApi
 * @extends {BaseAPI}
 */
export class CertificateApi extends BaseAPI {
    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerDeleteCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerDeleteCertificate(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerDeleteCertificates(store: CertificateStore, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerDeleteCertificates(store, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {ObjectEncoding} encoding 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerExportCertificate(store: CertificateStore, thumbprint: string, encoding: ObjectEncoding, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerExportCertificate(store, thumbprint, encoding, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ObjectEncoding} encoding 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerExportCertificateChain(encoding: ObjectEncoding, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerExportCertificateChain(encoding, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {ObjectEncoding} encoding 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerExportCertificates(store: CertificateStore, encoding: ObjectEncoding, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerExportCertificates(store, encoding, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {KeyExportFormat} keyExportFormat 
     * @param {ExportPrivateKeysRequestBody} exportPrivateKeysRequestBody 
     * @param {boolean} [includeRoot] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerExportPrivateKeys(store: CertificateStore, keyExportFormat: KeyExportFormat, exportPrivateKeysRequestBody: ExportPrivateKeysRequestBody, includeRoot?: boolean, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerExportPrivateKeys(store, keyExportFormat, exportPrivateKeysRequestBody, includeRoot, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerGetCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerGetCertificate(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [chain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerGetCertificateDetails(chain?: File, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerGetCertificateDetails(chain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return a list of objects that references the provided certificate. 
     * @summary Get all the references to a certificate
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerGetCertificateReferencedDetails(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerGetCertificateReferencedDetails(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerGetCertificates(store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerGetCertificates(store, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerGetCertificatesCount(store: CertificateStore, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerGetCertificatesCount(store, expired, missingKeyAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {CertificateImportAction} importAction 
     * @param {File} [certificates] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerImportCertificates(store: CertificateStore, importAction: CertificateImportAction, certificates?: File, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerImportCertificates(store, importAction, certificates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {CertificateImportAction} importAction 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerImportCertificatesBase64(store: CertificateStore, importAction: CertificateImportAction, body: string, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerImportCertificatesBase64(store, importAction, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {CertificateImportAction} importAction 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerImportCertificatesPEM(store: CertificateStore, importAction: CertificateImportAction, body: string, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerImportCertificatesPEM(store, importAction, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {MissingKeyAction} missingKeyAction 
     * @param {string} [keyStorePassword] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerImportPrivateKeys(store: CertificateStore, missingKeyAction: MissingKeyAction, keyStorePassword?: string, file?: File, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerImportPrivateKeys(store, missingKeyAction, keyStorePassword, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerImportSystemRoots(options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerImportSystemRoots(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If a certificate is referenced, for example because the certificate is selected as a signing certificate for a user, the certificate cannot be deleted because that would result in a database constraint violation. This operation will return true if the certificate is referenced. 
     * @summary Checks if the certificate is referenced
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerIsCertificateReferenced(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerIsCertificateReferenced(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} email 
     * @param {Match} match 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerSearchForCertificatesByEmail(store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerSearchForCertificatesByEmail(store, email, match, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} email 
     * @param {Match} match 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerSearchForCertificatesByEmailCount(store: CertificateStore, email: string, match: Match, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerSearchForCertificatesByEmailCount(store, email, match, expired, missingKeyAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} issuer 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerSearchForCertificatesByIssuer(store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerSearchForCertificatesByIssuer(store, issuer, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} issuer 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerSearchForCertificatesByIssuerCount(store: CertificateStore, issuer: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerSearchForCertificatesByIssuerCount(store, issuer, expired, missingKeyAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} subject 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerSearchForCertificatesBySubject(store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerSearchForCertificatesBySubject(store, subject, expired, missingKeyAlias, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} subject 
     * @param {Expired} expired 
     * @param {MissingKeyAlias} missingKeyAlias 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public certificateControllerSearchForCertificatesBySubjectCount(store: CertificateStore, subject: string, expired: Expired, missingKeyAlias: MissingKeyAlias, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).certificateControllerSearchForCertificatesBySubjectCount(store, subject, expired, missingKeyAlias, options).then((request) => request(this.axios, this.basePath));
    }
}

